import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CandidacySummaryChange, HttpResponse } from "@/types";

export function useGetCandidacySummaryChanges({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "candidacy_summary_changes",
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_summary_changes`;
      const res = await httpClient.get<
        CandidacySummaryChange[],
        HttpResponse<CandidacySummaryChange[]>
      >(path);
      return res.data;
    },
  });
}
